import { FC, useState } from "react";
import styles from "./News.module.scss";
import { Link } from "react-router-dom";
import cn from "classnames";

const News: FC = () => {
    const [currentPage, setCurrentPage] = useState(1);

    return (
        <div className="container">
            <div className={styles.header}>
                <h1 className={styles.headline}>Blog</h1>
                <div className={styles.breadcrumb}>
                    <img width={16} height={16} src="/images/swap/home.svg" alt="" />
                    <img style={{ opacity: 0.5 }} width={12} height={12} src="/images/swap/right.svg" alt="" />
                    <Link to={"/mint"}>BLOG</Link>
                </div>
            </div>
            <section className={styles.news}>
                <div className={styles.items}>
                    {[...new Array(1)]
                        .map((_, i) => i + 1)
                        .map((id) => (
                            <Link key={id} to={`/news/${id}`} className={styles.item}>
                                <h2 className={styles.title}>Beta verison</h2>
                                <p className={styles.description}>
                                    We welcome you to the beta version of the nestdex website!{" "}
                                </p>
                                <time className={styles.date} dateTime="2024-10-04">
                                    04.10.2024
                                </time>
                            </Link>
                        ))}
                </div>
                {/* <div className={styles.paginationHolder}>
     <div className={styles.pagination}>
      <button className={cn(styles.page, styles.previous)}>
       <img width={9} height={9} src="/images/scam/left.svg" alt="Go to the previous page" />
      </button>
      {[...new Array(5)]
       .map((_, i) => i + 1)
       .map((n) => (
        <button
         key={n}
         onClick={() => setCurrentPage(n)}
         className={cn(styles.page, {
          [styles.active]: n === currentPage,
         })}
        >
         {n}
        </button>
       ))}
      <button className={styles.page}>...</button>
      <button className={styles.page}>10</button>
      <button className={cn(styles.page, styles.next)}>
       <img width={9} height={9} src="/images/scam/left.svg" alt="Go to the next page" />
      </button>
     </div>
    </div> */}
            </section>
        </div>
    );
};

export default News;
